import {createFeatureSelector, createSelector} from '@ngrx/store';
import {CampaignState} from './campaign.reducer';

export const selectCampaignState = createFeatureSelector<CampaignState>('campaigns');

export const selectCurrentCampaignId = createSelector(
    selectCampaignState,
    (state: CampaignState) => state.campaign
);

export const selectCurrentCampaign = createSelector(
    selectCampaignState,
    (state: CampaignState) => state.campaigns.find(campaign => campaign.id === state.campaign)
);

export const selectAllCampaigns = createSelector(
    selectCampaignState,
    (state: CampaignState) => state.campaigns
);

export const selectCampaignsLoading = createSelector(
    selectCampaignState,
    (state: CampaignState) => state.loading
);

export const selectCampaignsError = createSelector(
    selectCampaignState,
    (state: CampaignState) => state.error
);
